import React from "react";
import LinkWrapper from "./linkWrapper/LinkWrapper";
import { prepareRichText, decodeText } from "../../utils/richText";
import { getAlignmentClasses } from "../../utils/alignment";
import { getTextSize } from "../../utils/textSize";

// Headline & Text content component, the ecom twin of demo-ftl-base's headlineAndText:
// eyebrow, title (its size doubles as the heading level), optional subtitle, rich-text body
// and one CTA. Styles live in assets/scss/_headline-text.scss.
const Headline = ({ eyebrow, title, subtitle, text, link = {}, titleTag, textAlignment, textSize }) => {
    const TitleTag = titleTag || "h2";
    const { textAlignmentClass } = getAlignmentClasses({ textAlignment });
    const body = prepareRichText(text);
    const bodySize = getTextSize(textSize);
    const label = decodeText(link.label);

    return (
        <div className={`headline-text ${textAlignmentClass || "text-start"}`}>
            {eyebrow && <span className="headline-text__eyebrow">{decodeText(eyebrow)}</span>}
            {title && <TitleTag className="headline-text__title">{decodeText(title)}</TitleTag>}
            {subtitle && <p className="headline-text__subtitle">{decodeText(subtitle)}</p>}
            {body && <div className={`headline-text__body headline-text__body--${bodySize}`} dangerouslySetInnerHTML={{ __html: body }} />}
            {label && (
                <div className="headline-text__cta btn-hover">
                    <LinkWrapper linkNode={link} linkClass="default-btn">
                        {label}
                    </LinkWrapper>
                </div>
            )}
        </div>
    );
};

export default Headline;
